<div
  class="container-fluid d-flex text-light flex-nowrap flex-column justify-content-center align-items-center c-height 333"
>
  <div class="custom-max-width">
    <div class="column slideInUp">
      <h1
        class="display-2 mb-3 text-center m-top-10"
        style="font-weight: 600; margin-top: 10rem"
      >
        {{ heading }}
      </h1>
      <p *ngIf="sub_heading != ''" class="text-center">{{ sub_heading }}</p>
    </div>
  </div>
</div>

<div
  *ngIf="breadcrumbs && breadcrumbs.length > 0"
  class="222 d-flex flex-row flex-wrap position-absolute bottom-0 custom-mx-5"
>
  <div
    class="d-flex flex-row flex-nowrap align-items-center text-white"
    *ngFor="let item of breadcrumbs; let i = index"
  >
    <span *ngIf="i != 0" class="m-2 text-white">></span>
    <p-button
      [styleClass]="'p-button-text headingbutton text-white'"
      [routerLink]="'/all-data-view'"
      [queryParams]="{ id: item.id }"
    >
      {{ item.label }}
    </p-button>
  </div>
</div>
